import { render, staticRenderFns } from "./lookRedCard.vue?vue&type=template&id=601f736c&scoped=true&"
import script from "./lookRedCard.vue?vue&type=script&lang=js&"
export * from "./lookRedCard.vue?vue&type=script&lang=js&"
import style0 from "./lookRedCard.vue?vue&type=style&index=0&id=601f736c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f736c",
  null
  
)

export default component.exports